import { render, staticRenderFns } from "./ActionsBlock.vue?vue&type=template&id=044cfbfc"
import script from "./ActionsBlock.vue?vue&type=script&lang=js"
export * from "./ActionsBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports